import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { AmazonRedshiftSink } from 'app/model/pipeline/copysink/amazon-redshift.copysink';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { CopySinkAdapter } from './copysink.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRedshiftSink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBehavior: '*'
    }
})
export class AmazonRedshiftSinkAdapter extends CopySinkAdapter<AmazonRedshiftSink, Model.AmazonRedshiftSink> {
    protected override async _toResource(model: AmazonRedshiftSink): Promise<Model.AmazonRedshiftSink> {
        const result: Model.AmazonRedshiftSink = {
            type: Metamodel.modelOf(model).name
        };
        TabularSinkAdapter.toSinkResource(model, result);
        result.writeBehavior = ValueAdapter.toResource(model, AmazonRedshiftSink.WRITE_BEHAVIOR);
        return result;
    }

    protected override async _toModel(
        resource: Model.AmazonRedshiftSink,
        owner: Activity
    ): Promise<AmazonRedshiftSink> {
        const result = Owned.create<AmazonRedshiftSink>(Metamodel.modelFor(AmazonRedshiftSink), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        ValueAdapter.toModel(result, AmazonRedshiftSink.WRITE_BEHAVIOR, resource.writeBehavior);
        return result;
    }
}